
export class OptimizedLocalStorageService {
  static get<T>(key: string): T | null {
    try {
      const item = localStorage.getItem(key);
      if (!item) return null;
      
      const parsed = JSON.parse(item);
      
      // Check if the item has an expiration
      if (parsed.expiry && Date.now() > parsed.expiry) {
        localStorage.removeItem(key);
        return null;
      }
      
      return parsed.value || parsed;
    } catch (error) {
      console.error('Error reading from localStorage:', error);
      return null;
    }
  }

  static set<T>(key: string, value: T, expiryMinutes?: number): void {
    try {
      let item: any = { value };
      
      if (expiryMinutes) {
        item.expiry = Date.now() + (expiryMinutes * 60 * 1000);
      }
      
      localStorage.setItem(key, JSON.stringify(item));
    } catch (error) {
      console.error('Error writing to localStorage:', error);
    }
  }

  static remove(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Error removing from localStorage:', error);
    }
  }

  static clear(): void {
    try {
      localStorage.clear();
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  }

  // Optimized cart methods
  static getOptimizedCartItems(userId: string): any[] {
    if (!userId) {
      return [];
    }
    return this.get<any[]>(`optimized-cart-${userId}`) || [];
  }

  static setOptimizedCartItems(userId: string, items: any[]): void {
    if (!userId || !Array.isArray(items)) {
      return;
    }
    this.set(`optimized-cart-${userId}`, items);
  }

  // Optimized browsing history methods
  static getOptimizedBrowsingHistory(userId: string): any[] {
    if (!userId) {
      return [];
    }
    return this.get<any[]>(`optimized-browsing-history-${userId}`) || [];
  }

  static setOptimizedBrowsingHistory(userId: string, history: any[]): void {
    if (!userId || !Array.isArray(history)) {
      return;
    }
    this.set(`optimized-browsing-history-${userId}`, history);
  }
}
